export const ACCOUNT_TYPE_LABELS = {
  CUSTOMER: 'Müşteri',
  PARTNER: 'Firma',
  TEKLIF: 'Teklif',
  EMPLOYEE: 'Personel'
};

export const EMPLOYMENT_TYPE_LABELS = {
  FIXED: 'Sabit',
  DAILY: 'Yevmiyeli'
};

export const getAccountTypeLabel = (value) => ACCOUNT_TYPE_LABELS[value] || value || '-';

export const PERSONNEL_GROUP_LABELS = {
  SUPERVISOR: 'Süpervizör',
  OFFICE: 'Ofis',
  FIELD: 'Saha Operasyon'
};

export const getEmploymentTypeLabel = (value) => EMPLOYMENT_TYPE_LABELS[value] || value || '-';

export const getPersonnelGroupLabel = (value) => PERSONNEL_GROUP_LABELS[value] || value || '';
